module.exports = __webpack_public_path__ + "static/media/old sf-steuart-3.33d1c5b4.png";